import React from "react";
import {
  Dialog,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import "../styles/dialog-premium.css";

interface AIDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onGenerate: () => void;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  cancelButtonName: string;
  confirmButtonName: string;
  format?: string;
}

const AIDialog: React.FC<AIDialogProps> = ({
  open,
  title,
  onClose,
  onGenerate,
  value,
  onChange,
  cancelButtonName,
  confirmButtonName,
  format,
}) => {
  const getPlaceholder = () => {
    switch (format) {
      case "Instagram_Story":
        return 'Enter a prompt, e.g. "A team in a meeting room celebrating a company milestone."';
      case "Instagram_Ad":
        return "Describe the image you want for your Instagram ad...";
      case "Facebook_Post":
        return 'Enter a prompt, e.g. "A happy employee sharing their experience at a dynamic company."';
      case "Facebook_Ad":
        return 'Enter a prompt, e.g. "A professional showcasing workplace culture."';
      case "LinkedIn_Post":
      case "LinkedIn_Post_Landscape":
        return 'Enter a prompt, e.g. "Young professionals collaborating in a modern office."';
      default:
        return 'Enter a prompt, e.g. "Young professionals collaborating in a modern office."';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      className="premium-dialog-root confirmation-box"
      BackdropProps={{ className: "premium-modal-backdrop" }}
      PaperProps={{
        elevation: 0,
        className: "premium-dialog-paper premium-dialog-paper--wide",
      }}
    >
      <div className="premium-dialog-header">
        <h2 className="premium-dialog-title">{title}</h2>
        <button
          type="button"
          className="premium-dialog-close"
          onClick={onClose}
          aria-label="close dialog"
        >
          <CloseRoundedIcon sx={{ fontSize: 18 }} />
        </button>
      </div>

      <div className="premium-dialog-body premium-dialog-body--with-icon">
        <div className="premium-dialog-icon premium-dialog-icon--info">
          <AutoAwesomeRoundedIcon />
        </div>
        <div className="premium-dialog-content">
          <label htmlFor="ai-prompt" className="premium-dialog-label">
            Describe what you want to generate
          </label>
          <textarea
            id="ai-prompt"
            className="premium-dialog-textarea"
            autoFocus
            placeholder={getPlaceholder()}
            value={value}
            onChange={onChange}
            rows={6}
          />
        </div>
      </div>

      <div className="premium-dialog-footer">
        <button
          type="button"
          className="premium-dialog-btn premium-dialog-btn--cancel"
          onClick={onClose}
        >
          {cancelButtonName}
        </button>
        <button
          type="button"
          className="premium-dialog-btn premium-dialog-btn--confirm"
          onClick={onGenerate}
        >
          {confirmButtonName}
        </button>
      </div>
    </Dialog>
  );
};

export default AIDialog;
